module.exports = __webpack_public_path__ + "img/account_v03_icona_mail.19168ca8.png";